export const SET_TRANSACTION_TYPES = "SET_TRANSACTION_TYPES";
export const GET_TRANSACTION_DETAIL = "GET_TRANSACTION_DETAIL";
export const GET_TRANSACTION_DETAIL_SUCCESS = "GET_TRANSACTION_DETAIL_SUCCESS";
export const GET_TRANSACTION_DETAIL_FAIL = "GET_TRANSACTION_DETAIL_FAIL";
export const CLEAR_SELECTED_AGENT_ACCOUNT = "CLEAR_SELECTED_AGENT_ACCOUNT";
export const SET_TRANSACTION_QUERY = "SET_TRANSACTION_QUERY";
export const GET_TRANSACTION_BREAKDOWN_SUCCESS =
  "GET_TRANSACTION_BREAKDOWN_SUCCESS";
export const GET_TRANSACTION_BREAKDOWN_FAIL = "GET_TRANSACTION_BREAKDOWN_FAIL";
export const GET_TRANSACTION_BREAKDOWN = "GET_TRANSACTION_BREAKDOWN";
export const SET_CURRENT_TRANSACTION = "SET_CURRENT_TRANSACTION";
export const CLEAR_TRANSACTION_DETAIL = "CLEAR_TRANSACTION_DETAIL";
export const GET_SEARCHED_AGENT = "GET_SEARCHED_AGENT";
export const GET_SEARCHED_AGENT_SUCCESS = "GET_SEARCHED_AGENT_SUCCESS";
export const GET_SEARCHED_AGENT_FAIL = "GET_SEARCHED_AGENT_FAIL";
export const SET_SEARCHED_AGENT = "SET_SEARCHED_AGENT";
export const RESET_SEARCHED_AGENT = "RESET_SEARCHED_AGENT";
export const DOWNLOAD_TRANSACTION_DETAIL = " DOWNLOAD_TRANSACTION_DETAIL";
export const DOWNLOAD_TRANSACTION_DETAIL_COMPLETE =
  "DOWNLOAD_TRANSACTION_DETAIL_COMPLETE";
